import React from "react";

export default function Scrolltop() {
  return (
    <>
      <a href="#" className="scrollToTop">
        <i className="icofont-stylish-up"></i>
      </a>
    </>
  );
}
